import { render } from "./ButtonLayout.vue?vue&type=template&id=48b6a6c9&scoped=true"
import script from "./ButtonLayout.vue?vue&type=script&lang=js"
export * from "./ButtonLayout.vue?vue&type=script&lang=js"

import "./ButtonLayout.vue?vue&type=style&index=0&id=48b6a6c9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-48b6a6c9"

export default script